<template>
  <nav
    v-show="showNavigation"
    class="m-the-header-navigation"
  >
    <ul>
      <li
        v-for="(navItem, index) in navigationItems"
        :key="index"
      >
        <a
          v-if="navItem.subMenu"
          class="m-the-header-navigation-access-submenu"
          href="/aside"
          :id="`subitem-${navItem.routeName}`"
          @click.prevent="$utils.switchAsideNavigationMenu()"
        >
          <i class="fas fa-bars"></i>
          {{ $t('mTheHeaderNav.subMenu') }}
        </a>
        <a
          :class="navItem.class"
          :disabled="!isLoading"
          href="#"
          @click.prevent="gotToSection(navItem)"
        >
          <i :class="navItem.icon"></i>
          <span class="section-name">{{ navItem.text  }}</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'MoleculeTheHeaderNavigation',

  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      headerNavigation: {},
      itemActive: '',

      navigationItems: [
        {
          brand: 'projects',
          class: '',
          edition: '',
          icon: 'fad fa-folder-open',
          routeName: 'projects',
          subMenu: false,
          text: '',
          to: ''
        },

        {
          brand: 'products',
          class: '',
          edition: '',
          icon: 'fad fa-box-open',
          routeName: 'products',
          subMenu: false,
          text: '',
          to: ''
        },

        {
          brand: 'billing',
          class: '',
          edition: '',
          icon: 'fad fa-credit-card',
          routeName: 'billing',
          subMenu: false,
          text: '',
          to: ''
        },

        {
          brand: 'academy',
          class: '',
          edition: '',
          icon: 'fad fa-school',
          routeName: 'academy',
          subMenu: false,
          text: '',
          to: ''
        }
      ]
    }
  },

  computed: {
    showNavigation () {
      return this.$route.name !== 'accessDenied' && this.$route.name !== 'home'
    }
  },

  watch: {
    $route (to, from) {
      this.setNavigationItemsClasses()
    }
  },

  created () {
    this.setNavigationItemsRoutes()
    this.setNavigationItemsClasses()
  },

  methods: {
    gotToSection (navItem) {
      if (!this.isLoading || navItem.routeName === 'academy' ||
        navItem.routeName === 'billing' || navItem.routeName === 'products') {
        this.$router.push(navItem.to)
      }
    },

    setNavigationItemsClasses () {
      if (this.$route.meta.isEdition === 'product') {
        this.itemActive = 'products'
      } else if (this.$route.meta.isEdition === 'asset' || this.$route.meta.isEdition === 'map') {
        this.itemActive = 'projects'
      } else {
        this.itemActive = this.$route.meta.isEdition
      }

      this.navigationItems.forEach(navItem => {
        navItem.text = this.$t(`mTheHeaderNav.${navItem.brand}`)
        navItem.class = navItem.routeName === this.itemActive
          ? `m-the-header-navigation-item-active m-the-header-navigation-item-${navItem.brand}-active`
          : `m-the-header-navigation-item-${navItem.brand}`
        navItem.subMenu = navItem.routeName === this.itemActive &&
          this.$route.meta.isEdition !== 'products' &&
          this.$route.meta.isEdition !== 'projects'
      })
    },

    setNavigationItemsRoutes () {
      this.navigationItems.forEach(navItem => {
        navItem.to = this.$router.options.routes.find(route => route.name === navItem.routeName).path
      })

      this.navigationItems[2].to = `${(this.navigationItems[2].to).replace('/:subject', '/')}${this.$t('mEditionMenu.billing.mySales.subject')}`
      this.navigationItems[3].to = `${(this.navigationItems[3].to).replace('/:subject', '/')}${this.$t('mEditionMenu.academy.users.subject')}`
    }
  }
}
</script>
